import SignInCallToAction from "../SignInCallToAction";
import { getUserProperties } from '../../helpers/authHelper';
import { encodeProfileURL } from '../../helpers/urlHelper';

function AddContributionSection(props) {
  const {
    isUserLoggedIn,
    totalCommentsLength,
    setShowModal,
    showModal,
    appType,
    pinSelected,
    validAddressForNewPin,
    isOrganisation,
    organisationName
  } = props;

  const user = getUserProperties();
  
  return isUserLoggedIn ? (
    // Don't show the CTA if there is an app type provided and that there is a selected pin
    isUserLoggedIn && (!appType || (appType && pinSelected)) && (
      <div className="ugc-comments-list__add-contribution">
        <div
          className="ugc-comments-list__add-contribution-cta">
            {
              user?.avatarUrl &&
              <img
              className="ugc__avatar"
              src={`${user?.avatarUrl}?autorotate=true`}
              width="144"
              height="144"
              alt="User avatar"/>
          }

          <div className="ugc-comments-list__add-contribution-profile">
            {
              isOrganisation ?
              <span>
              Logged in as {organisationName}...
                <a
                  href={encodeProfileURL(organisationName)}>
                  View your profile
              </a>
            </span>
              :
              user?.firstName && user?.lastName ?
                <span>
                Logged in as {user.firstName} {user.lastName}...
                  <a
                    href={encodeProfileURL(`${user.firstName}${user.lastName}`, user?.userId)}>
                    View your profile
                </a>
              </span>
                : user?.firstName ?
                  <span>
                  Logged in as {user.firstName}...
                    <a href={encodeProfileURL(user.firstName, user?.userId)}>
                      View your profile
                  </a>
                </span>
                  :
                  <span>
                You are logged in...
                    <a
                       href={encodeProfileURL('default')}>
                      View your profile
                  </a>
              </span>
            }

            <p className="h3 ugc-comments-list__add-contribution-comments">
              {totalCommentsLength === 1 ? 'There is 1 comment.' : `There are ${totalCommentsLength} comments`}
            </p>
            { validAddressForNewPin || !appType ?
               <button
                className="govuk-button he-button he-button__secondary ugc-comments-list__add-contribution-button"
               onClick={() => setShowModal(!showModal)}
               data-component="ugcAddYourCommentsButton">
               Add your comments, photos or videos now
             </button> 
             :
             <></>
            }
           
          </div>
        </div>
      </div>
    )
  ) : (
    <SignInCallToAction
      appType={appType}
      totalCommentsLength={totalCommentsLength}/>
  );
}

export default AddContributionSection;
